// infinite scroll
class MarqueeComponent extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.marquee-inner');
    this.marqueeList = this.querySelector('.marquee--list');
    this.marqueeListClone = this.marqueeList.cloneNode(true);

    this.marqueeListClone.classList.add('marquee-duplicate');
    this.marqueeListClone.classList.remove('marquee-original');

    this.windowWidth = window.innerWidth;
    this.marqueeListWidth = this.marqueeList.offsetWidth;
  }

  connectedCallback() {
    (this.windowWidth > this.marqueeListWidth) ? this.initializeMarqueeDuplicates() : this.initializeMarquee();
  }

  initializeMarquee() {
    this.container.appendChild(this.marqueeListClone);
    this.container.style.width = `${2 * this.marqueeListWidth}px`;
  }

  initializeMarqueeDuplicates() {
    const marqueeListCloneRemaining = Math.floor(this.windowWidth / this.marqueeListWidth);
    const marqueeListCloneCount = Math.floor(marqueeListCloneRemaining * 2 - 1);

    for (let i = 0; i < marqueeListCloneCount; i++) {
      const clonedContent = this.marqueeList.cloneNode(true);
      clonedContent.classList.add('marquee-duplicate', `marquee-duplicate--${i}`);
      clonedContent.classList.remove('marquee-original');
      this.container.appendChild(clonedContent);
    }

    this.container.style.width = `${2 * this.windowWidth}px`;

    const marqueeLists = this.querySelectorAll('.marquee--list');
    const marqueeListWidth = this.windowWidth / marqueeListCloneRemaining;

    marqueeLists.forEach(element => {
      element.style.width = `${marqueeListWidth}px`;
    });
  }
}

customElements.define('marquee-component', MarqueeComponent);

// swiper component
class SwiperComponents extends HTMLElement {
  constructor() {
    super();
    this.initSwiper = this.getAttribute('data-swiper');
    this.swiperSlides = this.getAttribute('data-slides');
    this.swiperMobileSlides = this.getAttribute('data-mobile-slides');
    this.spaceBetween = this.getAttribute('data-spaceBetween');
    this.autoHeight = this.getAttribute('data-autoHeight');
    this.swiperAutoHeight = this.autoHeight === 'true';

    if(this.initSwiper === 'false') return;
    this.swiperSlide();

    this.style.setProperty('--swiper-height', `${this.querySelector('.swiper-wrapper').offsetHeight}px`);
  }

  swiperSlide() {
    var swiper = new Swiper(this.querySelector('[id^="Swiper-"]'), {
      autoHeight: this.swiperAutoHeight,
      slidesPerView: this.swiperMobileSlides,
      spaceBetween: this.calculateSpaceBetween(),
      pagination: {
        el: this.querySelector('[id^="SwiperPagination-"]'),
        clickable: true
      },
      navigation: {
        prevEl: this.querySelector('[id^="SwiperPrev-"]'),
        nextEl: this.querySelector('[id^="SwiperNext-"]')
      },
      breakpoints: {
        750: {
          slidesPerView: this.swiperMobileSlides,
          spaceBetween: this.calculateSpaceBetween(),
        },
        990: {
          slidesPerView: this.swiperSlides,
          spaceBetween: this.spaceBetween,
        }
      }
    });
  }

  calculateSpaceBetween() {
    return this.spaceBetween.toString() === '0' ? 0 : Math.floor(this.spaceBetween / 2);
  }
}

customElements.define('swiper-component', SwiperComponents);

// testimonial
class TestimonialSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.testimonialFirst = this.querySelector('[id^="testimonial-1-"]');
    this.testimonialSecond = this.querySelector('[id^="testimonial-2-"]');
    if (!this.testimonialFirst || !this.testimonialSecond) return;
    this.initPages();
  }
  initPages() {
    var testimonialSecond = new Swiper(this.testimonialSecond, {
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true
    });
    var testimonialFirst = new Swiper(this.testimonialFirst, {
      effect: "fade",
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      thumbs: {
        swiper: testimonialSecond
      }
    });
  }
}
customElements.define('testimonial-component', TestimonialSliderComponent);

// Shop by size
class ShopBySizeFilter extends HTMLElement {
  constructor() {
    super();
    this.onVariantSizeChange = this.onVariantSizeChange.bind(this);
    this.onClickToggle = this.onClickToggle.bind(this);
  }

  connectedCallback() {
    // Attach event listener only once DOM is ready
    this.addEventListener('change', this.onVariantSizeChange);
    this.addEventListener('click', this.onClickToggle);
  }

  disconnectedCallback() {
    // Clean up when element is removed
    this.removeEventListener('change', this.onVariantSizeChange);
    this.removeEventListener('click', this.onClickToggle);
  }

  onClickToggle(e) {

    this.querySelector('.series-list--dropdown-button')?.classList.toggle('has-active');
    const panel = this.querySelector('.facets-by-size-js');
    if (panel) {
      panel?.classList.toggle('has-active');
      panel?.classList.toggle('hidden');
    }
    
  }

  onVariantSizeChange() {
    const fieldsets = Array.from(this.querySelectorAll('.facets__list'));
    const selectedValues = [];

    fieldsets.forEach(fieldset => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));

      // Remove active class from all before reapplying
      inputs.forEach(input => input.classList.remove('input-active'));



      // Find and mark the selected one
      const checkedInput = inputs.find(input => input.checked);

      if (checkedInput) {
        document.querySelector(".select-size-append").innerHTML = checkedInput.value;
        checkedInput?.classList.add('input-active');
        selectedValues.push(checkedInput.value);

        this.onClickToggle();
      }
    });

    // Combine selected values (use ',' if multiple)
    const combinedValue = selectedValues.join(',');
    const productElements = document.querySelectorAll('.product-shop-by-size');

    productElements.forEach(el => {
      const dataSize = el.dataset.size?.trim();
      el.style.display = combinedValue === dataSize ? 'block' : 'none';
    });
  }
}
customElements.define( 'facets-shop-by-size', ShopBySizeFilter);

// customer nav
class CustomerNavComponents extends HTMLElement {
  constructor() {
    super();

    this.profile = this.querySelector('.js-nav-toggle');
    this.profileName = this.querySelector('.customer-profile--heading');
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      this.expanded = this.getAttribute('aria-expanded');

      if(!this.profileName.contains(event.target)) this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
    });
  }
}

customElements.define('customer-nav', CustomerNavComponents);

// media alternates
class MediaAlternateComponents extends HTMLElement {
  constructor() {
    super();

    this.alternateButtonWrap = this.querySelector('.js-alternate__buttons');
    this.alternateLabel = this.querySelector('.js-alternate-label');
    this.alternateLabelText = this.querySelector('.js-alternate-label-text');
    this.alternateButtons = this.querySelectorAll('.js-alternate-button');
    this.alternateImages = this.querySelectorAll('.js-alternate-media');
  }

  connectedCallback() {
    window.matchMedia('(max-width: 750px)').addEventListener('change', () => {
      this.mediaAlternateSwiper();
      if(!this.alternateButtons) return;
      this.moveAlternateButtons();
    });
    if(window.innerWidth < 750) {
      this.mediaAlternateSwiper();
      if(!this.alternateButtons) return;
      this.moveAlternateButtons();
    }

    if(!this.alternateButtons) return;
    window.addEventListener('load', () => this.setMediaAlternateWidth());
    this.popupToggle();
    this.mediaAlternate();
  }

  setMediaAlternateWidth() {
    this.style.setProperty('--media-alternates-width', `${this.querySelector('.alternate__buttons-wrap').offsetWidth}px`);
  }

  popupToggle() {
    this.alternateLabel.addEventListener('click', () => {
      this.expanded = this.alternateButtonWrap.getAttribute('aria-expanded');
      this.alternateButtonWrap.setAttribute('aria-expanded', (this.expanded === 'false').toString());
    });
  }

  mediaAlternate() {
    this.alternateButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const alternateTarget = button.getAttribute('aria-label');

        this.alternateButtonWrap.setAttribute('aria-expanded', 'false');
        if(button.classList.contains('active')) return;

        this.alternateLabelText.innerText = alternateTarget;
        this.alternateImages.forEach((altImage) => altImage.dataset.media === alternateTarget ? altImage.classList.remove('hidden') : altImage.classList.add('hidden'));
        this.alternateButtons.forEach((button) => button.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }

  mediaAlternateSwiper() {
    var swiper = new Swiper(this.querySelector('#swiper-mediaAlternates'), {
      slidesPerView: 1,
      scrollbar: {
        el: this.querySelector('#swiper-mediaAlternatesScrollbar'),
        hide: true
      }
    });
  }

  moveAlternateButtons() {
    window.innerWidth < 750 ? this.append(this.alternateButtonWrap) : this.querySelector('.product__media-item--inner').append(this.alternateButtonWrap);
  }
}

customElements.define('media-alternates', MediaAlternateComponents);
